// react-router-dom components
import { NavLink } from 'react-router-dom'

// @mui material components
import Card from '@mui/material/Card'
import { GoogleLogin } from '@react-oauth/google'

// Material Dashboard 2 React components
import MDBox from '../../../components/MDComponents/MDBox'
import MDTypography from '../../../components/MDComponents/MDTypography'
import MDInput from '../../../components/MDComponents/MDInput'

import CoverLayout from '../../../layouts/authentication/components/CoverLayout'
import useLogin from './useLogin'
import Button from '../../../components/Button'
import { useMaterialUIController } from '../../../context'

import pages from 'constants/pages'

const Login = () => {
  const {
    rememberMe,
    handleSetRememberMe,
    handleGoogleLoginSuccess,
    wrongPassword,
    handleSubmit,
    inputs,
    handleChange,
    errors,
    isLoading,
    handleGoogleLoginError,
    loginError,
  } = useLogin()
  const [controller] = useMaterialUIController()
  const { theme } = controller
  const disableLoginButton =
    inputs.email.trim().length === 0 || inputs.password.trim().length === 0
  return (
    <CoverLayout>
      <Card className="!bg-secondary-background">
        <div className="bg-btn-primary rounded-lg mx-2 p-5 mt-[-1.5rem] text-center">
          <div className="!text-over-primary font-bold text-xl p-2">
            Autentifică-te
          </div>
        </div>
        <MDBox pt={4} pb={3} px={3}>
          <form>
            <MDBox id="login-form" role="form" component="form" method="POST">
              <MDBox mb={2}>
                <MDInput
                  id="email-input"
                  variant="standard"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ style: { fontSize: 16 } }}
                  type="email"
                  label="Email"
                  fullWidth
                  value={inputs.email}
                  name="email"
                  onChange={handleChange}
                  error={errors.emailError}
                />
                {errors.emailError ? (
                  <MDTypography
                    variant="caption"
                    color="error"
                    fontWeight="light"
                  >
                    Emailul nu este valid
                  </MDTypography>
                ) : null}
              </MDBox>
              <MDBox mb={2}>
                <MDInput
                  id="password-input"
                  inputProps={{ style: { fontSize: 16 } }}
                  placehlder="Parola"
                  variant="standard"
                  showPassword
                  InputLabelProps={{ shrink: true }}
                  type="password"
                  label="Password"
                  fullWidth
                  name="password"
                  value={inputs.password}
                  onChange={handleChange}
                  error={errors.passwordError}
                />
                {loginError ? (
                  <MDTypography
                    variant="caption"
                    color="error"
                    fontWeight="light"
                    id="login-error"
                  >
                    Email sau parola greșite
                  </MDTypography>
                ) : null}
              </MDBox>

              <label
                htmlFor="rememberUser"
                className="flex flex-row w-full gap-[5px] cursor-pointer"
              >
                <input
                  type="checkbox"
                  name="rememberUser"
                  id="rememberUser"
                  className="aspect-square w-[20px] h-[20px]"
                  defaultChecked={rememberMe}
                  checked={rememberMe}
                  onChange={handleSetRememberMe}
                />
                <span className="text-over-primary-background opacity-70">
                  Ține-mă minte
                </span>
              </label>

              <MDBox
                display="flex"
                alignItems="center"
                justifyContent="center"
                pt={1}
              >
                <GoogleLogin
                  theme={theme === 'dark' ? 'filled_black' : 'filled_white'}
                  onSuccess={handleGoogleLoginSuccess}
                  onError={handleGoogleLoginError}
                />
              </MDBox>
              <MDBox mt={2} mb={1}>
                <Button
                  disabled={disableLoginButton}
                  id="login-button"
                  onClick={handleSubmit}
                  className="w-full h-10 bg-btn-primary"
                  isLoading={isLoading}
                  type="submit"
                >
                  Autentifică-te
                </Button>
              </MDBox>
              {wrongPassword && (
                <MDTypography
                  variant="caption"
                  color="error"
                  fontWeight="light"
                >
                  Parolă sau adresă de email greșită
                </MDTypography>
              )}
              <MDBox mt={3} mb={1} textAlign="center">
                <div className="!text-over-secondary-background pb-1 text-sm">
                  Ți-ai uitat parola?{' '}
                  <NavLink
                    to={pages.auth.forgotPassword}
                    className="text-primary font-medium"
                  >
                    Recupereaz-o!
                  </NavLink>
                </div>
                <div className="!text-over-secondary-background pb-1 text-sm">
                  Nu ai încă un cont?{' '}
                  <NavLink
                    id="register-tab-button"
                    className="text-primary font-medium"
                    to={pages.auth.register}
                  >
                    Înregistrează-te!
                  </NavLink>
                </div>
              </MDBox>
            </MDBox>
          </form>
        </MDBox>
      </Card>
    </CoverLayout>
  )
}

export default Login
